import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelCheck from '../../../../../components/extras/SidePanelCheck';
import TableChecks from '../../../../../components/tables/tableChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemCheck } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


const pageSize = 10;

export const EDVChecksMyChecksPage = () => {
  const { parameters, menu, idUser } = useGlobalState();



  const [editIntructor, setEditIntructor] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [showVoid, setShowVoid] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [filteringText, setFilteringText] = useState("");
  const [sideOpen, setSideOpen] = useState(false);
  const [userPickerModal, setUserPickerModal] = useState(false);
  const [activeTab, setActiveTab] = useState("search");
  const mountedRef = useRef(false);



  const [check, setCheck] = useState<ItemCheck>();
  const [mychecks, setMychecks] = useState<ItemCheck[]>([]);


  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) {
        if (!mountedRef.current) {
          handleCheckMine();
          mountedRef.current = true;
        }
        handleCheckGet(parseInt(id))
      } else {
        setCheck(undefined)
        handleCheckMine();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleCheckGet = async (idRequest: Number) => {
    try {
      setCheck(undefined)
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/instruction/requests/request',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          idRequest: idRequest
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setCheck(data.check);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleCheckMine = async () => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/instruction/requests/search',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          columns: "idCheck, idRequest, [check], displayName, instructor, statusRequest, equipmentCheck, dateSubmited, idInstructor, dateAssigned, dateResult, idRequestReference",
          pending: false,
          orderBy: "dateSubmited",
          order: "desc",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setMychecks(data.checks);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  const handleCheckEval = (idCheckParameter: string, opt: any) => {
    if (check && check.statusRequest == 1 && check.idInstructor == idUser && activeTab === "mychecks") {
      setCheck((prev: any) => ({
        ...prev,
        jsonResults: prev.jsonResults.map((item: any) =>
          item.idCheckParameter === idCheckParameter
            ? { ...item, resultValue: opt.value, resultText: opt.text }
            : item
        ),
      }));
    }
  };



  type Tab = {
    label: string;
    id: string;
    content: React.ReactNode;
  };

  const [currentPageIndex, setCurrentPageIndex] = useState(1);


  const filtered: any[] = mychecks.filter((item) => {
    const normalize = (str: string | undefined | null) =>
      (str || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
    const searchWords = normalize(filteringText).split(/\s+/).filter(Boolean);
    const text = normalize([item?.instructor, item?.displayName, item?.check,].join(" "));
    return searchWords.every((word) => text.includes(normalize(word)));
  });


  const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
  return (
    <CustomAppLayout
      toolsHide
      splitPanelOpen={!!check}

      onSplitPanelToggle={({ detail }) => {
        !detail.open ? window.location.hash = "edv/checks/mychecks" : null
      }}

      splitPanelSize={600}
      splitPanel={
        <SidePanelCheck Check={check} />
      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">
            <Header actions={<Favorites />}


            >
              Mis chequeos realizados
            </Header>


            <SpaceBetween direction='vertical' size='xs'>
              {mychecks && (
                <TableChecks checks={mychecks} onSelect={(item: ItemCheck) => window.location.hash = `edv/checks/mychecks?id=${item.idRequest}`}
                  showInstructor={false}
                />
              )}
            </SpaceBetween>

          </SpaceBetween>



        </>
      }
    />
  );
};

function getColor(hex: string): "green" | "blue" | "red" | "grey" | "severity-low" {
  switch (hex.toLowerCase()) {
    case "#00b000":
      return "green";
    case "#007cff":
      return "blue";
    case "#ff0000":
      return "red";
    case "#999999":
      return "severity-low";
    default:
      return "grey";
  }
}